module.exports = __webpack_public_path__ + "img/nao_trocar_objetos.a7272224.svg";